module.exports = __webpack_public_path__ + "37902a0ac84638427bec3f5d7080f0c6.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/soundway.jpg
 ** module id = 488
 ** module chunks = 0
 **/